import Service from "@/helpers/py-service";
const state = {
  loading: false,
  meta: {},
  list: [],
  //
  partners: [],
  dealers: [],
};

const mutations = {
  SET_META(state, data) {
    if (data.meta) {
      state.meta.page = data.meta.current_page;
      state.meta.itemsPerPage = data.meta.per_page;
      state.meta.lastPage = data.meta.last_page;
      state.meta.totalItems = data.meta.total;
    }
  },
  SET_PARTNERS(state, payload) {
    state.partners = payload;
  },
  SET_DEALERS(state, payload) {
    state.dealers = payload;
  },
  //
  SET_LIST(state, payload) {
    state.list = payload;
  },

  ADD_LIST(state, payload) {
    state.list.unshift(payload);
  },

  UPDATE_LIST(state, payload) {
    const item = state.list.find((item) => item.id === payload.id);
    Object.assign(item, payload);
  },

  DELETE(state, payload) {
    state.list.splice(state.list.map((o) => o.id).indexOf(payload.id), 1);
  },
};

const actions = {
  options: (store, params) => {
    store.state.loading = true;
    return Service.get(`charging-station/dealer-partners`, params)
      .then((data) => {
        store.commit(
          "SET_PARTNERS",
          data.body.filter((r) => r.type === "partner")
        );
        store.commit(
          "SET_DEALERS",
          data.body.filter((r) => r.type === "dealer")
        );
        // if (params.page) {
        //   store.commit("SET_META", res.body);
        //   store.commit("SET_LIST", res.body.data);
        // } else {
        //   store.commit("SET_LIST", res.body);
        // }
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },

  add: (store, params) => {
    store.state.loading = true;
    return Service.post(`charging-station/dealer-partners`, params)
      .then((data) => {
        store.commit("ADD_LIST", data.body);
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },

  update: (store, params) => {
    store.state.loading = true;
    return Service.update(`charging-station/dealer-partners`, params)
      .then((data) => {
        store.commit("UPDATE_LIST", data.body);
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },

  destroy: (store, params) => {
    return Service.destroy(`charging-station/dealer-partners`, params).then(
      (data) => {
        store.commit("DELETE", params);
        return data.body;
      }
    );
  },
};

const getters = {
  getLoading(state) {
    return state.loading;
  },

  getPartners(state) {
    return state.partners;
  },
  getDealers(state) {
    return state.dealers;
  },

  //
  getMeta(state) {
    return state.meta;
  },

  getList(state) {
    return state.list;
  },
};

const partnersAndDealers = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default partnersAndDealers;
